import React from 'react'
import { useTranslation } from 'react-i18next'

import { CookiePolicyLink } from 'components/CookiePolicyLink'

import { StyledCookieConsentBanner as S } from './CookieConsentBanner.styles'

type TCookieConsentBannerProps = {
  onAcceptAll: () => void
  onOpenPreferences: () => void
}

export const CookieConsentBanner: React.FC<TCookieConsentBannerProps> = ({
  onAcceptAll,
  onOpenPreferences,
}) => {
  const { t } = useTranslation()

  return (
    <S.BannerBar>
      <S.BannerLayout>
        <S.BannerCopy>
          <S.BannerTitle>{t('cookieConsent.title')}</S.BannerTitle>
          <S.BannerText>
            {t('cookieConsent.subtitle')}{' '}
            <CookiePolicyLink title="cookieConsent.cookieNotice" />
          </S.BannerText>
        </S.BannerCopy>

        <S.BannerActions>
          <S.BannerLink type="button" onClick={onOpenPreferences}>
            {t('actions.adjustTheSettings')}
          </S.BannerLink>

          <S.PrimaryButton type="button" onClick={onAcceptAll}>
            {t('actions.acceptAllCookies')}
          </S.PrimaryButton>
        </S.BannerActions>
      </S.BannerLayout>
    </S.BannerBar>
  )
}
